module.exports = __webpack_public_path__ + "img/roll5.0e6487b8.png";